module.exports = __webpack_public_path__ + "static/scale-model-of-the-golden-fire-hydrant-in-san-francisco-california-64c8252860a6c6e5ae47f890f480d43c.png";